import * as React from 'react';
import ResentTicketsForm from '../../../../../ResendTicketsForm';
import { useResendTickets } from '../../../../../Checkout/components/Checkout/hooks';
import { useSelector } from 'react-redux';
import { getOrder } from '../../../../../Checkout/store/order/selectors';
import { useTheme } from '../../../../../theme';
const SendTickets = props => {
    const order = useSelector(getOrder);
    const { resendStage, handleResendEmail } = useResendTickets(order.id);
    const theme = useTheme('FlightInfoCard').TicketsModal;
    return (React.createElement("div", { className: theme.sendTicketsContainer },
        React.createElement(ResentTicketsForm, { onSubmit: ({ email }) => handleResendEmail(email), hideHeader: true, status: resendStage, defaultEmail: order.customer.values.find(({ name }) => name === 'email').value, buttonClassName: theme.button, className: theme.resend_wrapper })));
};
export default SendTickets;
